import { type RouteRecordRaw } from "vue-router";
import { canAccess, permissionList } from "@/utilities/authorization";

const compositionRoutes: RouteRecordRaw[] = [
    {
        name: 'composition-new',
        path: '/composition/new/:id(\\d+)?',
        component: () => import('@/views/composition/NewComposition.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_COMPOSITION),
    },
    {
        name: 'composition-update',
        path: '/composition/update/:id(\\d+)',
        component: () => import('@/views/composition/UpdateComposition.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_COMPOSITION),
    },
]

export default compositionRoutes
